import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, ArrowRight } from 'lucide-react';
import { useMembership } from './MembershipCard';

export default function InnerCircleCard() {
  const [data] = useMembership();
  const m = data?.membership;
  if (!m || m.status !== 'active' || m.tier !== 'inner_circle') return null;
  return (
    <section className="rounded-2xl p-6 mb-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4 border"
      style={{ background: 'linear-gradient(100deg, rgba(249,115,22,0.12), var(--p-surface))', borderColor: 'rgba(249,115,22,0.35)' }} data-testid="inner-circle-card">
      <div>
        <div className="inline-flex items-center gap-1.5 text-xs font-bold text-[#F97316] uppercase tracking-wider mb-1"><Crown size={12} /> Inner Circle</div>
        <h3 className="text-lg font-semibold" style={{ fontFamily: 'Outfit, sans-serif' }}>Your weekly 20-min check-in with David</h3>
        <p className="text-sm mt-1" style={{ color: 'var(--p-muted)' }}>One check-in per week is included. Member price on 1-on-1 Strategy Sessions: $147.</p>
      </div>
      <div className="flex flex-col sm:items-end gap-2 shrink-0">
        <Link to={`/portal/book?service=${m.checkin_service_id}`} data-testid="inner-circle-book-checkin"
          className="inline-flex items-center gap-2 bg-[#F97316] hover:bg-[#EA580C] text-white px-5 py-2.5 rounded-xl font-medium text-sm transition-colors">
          Book this week's check-in <ArrowRight size={15} />
        </Link>
        <Link to="/portal/book" className="text-xs font-semibold hover:underline" style={{ color: 'var(--p-muted)' }} data-testid="inner-circle-book-strategy">Book a strategy session ($147)</Link>
      </div>
    </section>
  );
}
